export default "__VITE_ASSET__C8iuV$Lz__"